import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ToastContainer } from "react-toastify";
import {
  interviewActions,
  dispatchT_Language,
} from "../../Redux/ActionCreator.js";
import { ApiService } from "./api.service";

// Import English page components
import InterviewSetupPage from "./english/setup";
import InterviewSessionPage from "./english/sessionPage.jsx";
import AnalyticsPage from "./english/analytics.jsx";
import ResultsPage from "./english/result.jsx";

// Import Spanish page components
import Sp_InterviewSetupPage from "./spanish/sp_setup.jsx";
import Sp_InterviewSessionPage from "./spanish/sp_sessionPage.jsx";
import Sp_AnalyticsPage from "./spanish/sp_analytics.jsx";
import Sp_ResultsPage from "./spanish/sp_result.jsx";

const api = new ApiService();

const InterviewApp = () => {
  const dispatch = useDispatch();
  const flowLanguage = useSelector((e) => e.t_lang.selected);
  const { ui, questions, currentQuestionIndex } = useSelector(
    (state) => state.interview
  );
  const { currentStep } = ui;

  // Initialize app and check for existing interview data
  useEffect(() => {
    if (flowLanguage == null) {
      dispatch(dispatchT_Language("English")); // default language
    }
    initializeApp();
  }, []);

  // Check if we should move to results when all questions are completed  // Check if we should move to results when all questions are completed
  useEffect(() => {
    if (questions.length > 0 && currentQuestionIndex === questions.length - 1) {
      // Only move to results if the last question has been answered (has analytics)
      const lastQuestion = questions[currentQuestionIndex];
      if (
        lastQuestion?.analytics &&
        currentStep !== "results" &&
        currentStep !== "analytics"
      ) {
        const timer = setTimeout(() => {
          dispatch(interviewActions.setCurrentStep("results"));
        }, 100);
        return () => clearTimeout(timer);
      }
    }
  }, [
    questions.length,
    currentQuestionIndex,
    currentStep,
    questions,
    dispatch,
  ]);

  const initializeApp = async () => {
    try {
      // Check if there's existing interview data
      const response = await api.getQuestions();

      if (
        response.data &&
        response.data.interviewQuestionsId?.questions?.length > 0
      ) {
        dispatch(interviewActions.generateQuestionsSuccess(response.data));

        // Check if we have analytics for current question
        const currentQuestion =
          response.data.interviewQuestionsId.questions[currentQuestionIndex];
        if (currentQuestion?.analytics) {
          dispatch(interviewActions.setCurrentAnalytics(currentQuestion));
          dispatch(interviewActions.addQuestionAnalytics(currentQuestion));
          dispatch(interviewActions.setCurrentStep("analytics"));
        } else {
          dispatch(interviewActions.setCurrentStep("interview"));
        }
      } else {
        // No existing data, start fresh
        dispatch(interviewActions.setCurrentStep("setup"));
      }
    } catch (error) {
      console.error("Error initializing app:", error);
      // If there's an error getting existing data, start fresh
      dispatch(interviewActions.setCurrentStep("setup"));
    }
  };

  const renderCurrentPage = () => {
    switch (currentStep) {
      case "setup":
        if (flowLanguage == "English") return <InterviewSetupPage />;
        if (flowLanguage == "Spanish") return <Sp_InterviewSetupPage />;
      case "interview":
        if (flowLanguage == "English") return <InterviewSessionPage />;
        if (flowLanguage == "Spanish") return <Sp_InterviewSessionPage />;
      case "analytics":
        if (flowLanguage == "English") return <AnalyticsPage />;
        if (flowLanguage == "Spanish") return <Sp_AnalyticsPage />;
      case "results":
        if (flowLanguage == "English") return <ResultsPage />;
        if (flowLanguage == "Spanish") return <Sp_ResultsPage />;
      default:
        if (flowLanguage == "English") {
          return <InterviewSetupPage />;
        } else if (flowLanguage == "Spanish") {
          return <Sp_InterviewSetupPage />;
        }
    }
  };

  return (
    <div className="min-h-screen notranslate">
      {renderCurrentPage()}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};

export default InterviewApp;
